export default __webpack_public_path__ + "static/media/pakrap-9.03c24fe7.mp3";